import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useBranchDetails = () => {
  const [loading, setLoading] = useState(true);
  const [branchDetails, setBranchDetails] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const getBranchDetails = ({ branchGuid }) => {
    setLoading(true);

    axiosClient
      .get(`Product/Branch/Details?Guid=${branchGuid}`)
      .then(res => {
        if (res.status === 200) {
          setBranchDetails(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getBranchDetails, loading, branchDetails, setBranchDetails };
};

export default useBranchDetails;
